{
  "processPage": {
    "assignmentTitle": "Folyamatlépés hozzárendelés áttekintése",
    "assignmentDescription": "Ellenőrizze a hozzárendelés részleteit. Ha minden megfelelő, fogadja el, és kezdje meg a folyamatlépés rögzítését. Ha nem Ön a megfelelő személy, rendelje a lépést valaki máshoz.",
    "YourProcessStep": "Az Ön folyamatlépése",
    "ProcessStart": "Folyamat kezdete",
    "Output": "Kimenet",
    "Successor": "Utód",
    "Assignee": "Felelős",
    "chooseAllSuccessor": "Válasszon ki minden utódot, aki megkapja a kimenetét.",
    "chooseAllSuccessorDecision": "Válasszon ki minden utódot, aki folytatja a folyamatot ezzel az opcióval.",
    "chooseASuccessor": "Válasszon ki egy utódot, aki megkapja a kimenetét.",
    "chooseAllAssignee": "Válasszon ki mindenkit, aki elindíthatja a folyamatot.",
    "chooseAnAssignee": "Válassza ki, ki indítsa el a folyamatot.",
    "aSuccessorCanBe": "Az utód lehet személy, funkció, rendszer vagy külső kapcsolat.",
    "anAssigneeCanBe": "A felelős lehet személy, funkció vagy rendszer.",
    "addSuccessor": "Utód hozzáadása",
    "addAssignee": "Felelős hozzáadása",
    "whoElseDoesThis": "Ki csinálja még ezt?",
    "selectColleaguesWhoAlsoPerform": "Válassza ki azokat a személyeket, akik Öntől függetlenül átvehetnék ezt a lépést – pl. helyettesként. Több is megadható.",
    "statusPending": "Függőben",
    "Person": "Személy",
    "thisPersonWillReceive": "Ez a személy meghívót kap a következő folyamatlépés leírására.",
    "thisPersonWillReceiveStart": "Ez a személy meghívót kap az első folyamatlépés leírására.",
    "teamWillReceive": "Ez a funkció meghívót kap a következő folyamatlépés leírására.",
    "teamWillReceiveStart": "Ez a funkció meghívót kap az első folyamatlépés leírására.",
    "Unclear": "Nem egyértelmű",
    "processWillEnd": "A folyamat itt ér véget",
    "processWillReturnToOwner": "A folyamat visszakerül a folyamattulajdonoshoz",
    "None": "Nincs utód",
    "systemOwnerWillReceive": "A rendszer tulajdonosa meghívót kap a következő folyamatlépés leírására.",
    "systemOwnerWillReceiveStart": "A rendszer tulajdonosa meghívót kap az első folyamatlépés leírására.",
    "externalContactOwnerWillReceive": "A folyamattulajdonos meghívót kap a lépés leírására a külső kapcsolat nevében.",
    "selectPersonPlaceholder": "Válasszon személyt...",
    "selectSystemPlaceholder": "Válasszon szoftverrendszert...",
    "selectExternalContactPlaceholder": "Válasszon külső kapcsolatot...",
    "Processname": "Folyamat neve",
    "processFlow": "Folyamatábra",
    "processFlowDescription": "A teljes folyamatábra megtekintése az összes rögzített lépéssel",
    "showInProcess": "Megjelenítés a folyamatban",
    "viewProcessDetails": "Folyamat részleteinek megtekintése",
    "assignSomeoneElse": "Valaki más kijelölése",
    "Saved": "Mentve",
    "unsavedChanges": "Nem mentett módosítások",
    "processNameDesc": "Folyamat részletei",
    "multiple-times-daily": "Naponta többször",
    "once-a-day": "Naponta egyszer",
    "several-times-a-week": "Hetente többször",
    "once-per-week": "Hetente egyszer",
    "every-two-weeks": "Kéthetente",
    "every-three-weeks": "Háromhetente",
    "monthly": "Havonta",
    "quarterly": "Negyedévente",
    "semi-annually": "Félévente",
    "yearly": "Évente",
    "LastChange": "Utolsó módosítás",
    "ProcessStepMembers": "Folyamatlépés személyei",
    "ProcessStep": "Folyamatlépés",
    "Check": "Ellenőrzés",
    "ratingRequired": "Az értékelés kötelező",
    "Saving": "Mentés...",
    "surveyRequired": "Kérjük, adjon meg egy választ",
    "total": "Összesen: {{total}}",
    "showSelected": "Kiválasztottak megjelenítése ({{amount}})",
    "Reassign": "Átadás",
    "AllDepartments": "Összes osztály"
  },
  "processFlow": {
    "bpmnPreview": "Folyamat előnézet",
    "openFullscreen": "Teljes képernyő megnyitása",
    "fullscreenTitle": "Folyamatábra vizualizáció",
    "viewMode": {
      "label": "Nézet",
      "standard": "Alapértelmezett",
      "rating": "Értékelés szerint",
      "capacity": "Kapacitáslekötés szerint",
      "combined": "Kombinált pontszám"
    },
    "heatmapLegend": {
      "noData": "Nincs adat",
      "rating": {
        "good": "Átlag ≥ {{min}} csillag",
        "medium": "Átlag {{min}} – {{max}} csillag",
        "critical": "Átlag < {{min}} csillag"
      },
      "capacity": {
        "good": "< {{max}} % a maximumból",
        "medium": "{{min}} – {{max}} % a maximumból",
        "critical": "≥ {{min}} % a maximumból"
      },
      "combined": {
        "good": "Pontszám ≥ {{min}}%",
        "medium": "Pontszám {{min}} – {{max}}%",
        "critical": "Pontszám < {{max}}%"
      },
      "hoursUnit": "ó",
      "combinedInfo": "A kombinált pontszám 0–100% között értékel minden lépést, két dolgot ötvözve: mennyire jó az értékelése (60%) és mennyire alacsony a kapacitásterhelése (40%) — a kevesebb órát lekötő lépés magasabb pontszámot kap. A zöld mindkét szempontból jót jelent; a piros gyenge értékelést, magas kapacitásterhelést vagy mindkettőt jelez."
    },
    "stepDetails": "{{number}}. lépés részletei",
    "stepPrefix": "{{number}}. lépés",
    "decision": "Döntés",
    "assignedTo": "Felelős",
    "recordedBy": "Rögzítette",
    "taskDescription": "Feladat leírása",
    "inputs": "Bemenetek",
    "inputsHint": "Adjon hozzá mindent, ami beérkezik, és amire szüksége van a folyamatlépés végrehajtásához: egy eseményt, amely kiváltja a lépést (pl. negyedéves megbeszélés), vagy egy információt, amelyet feldolgoz (pl. egy jelentés vagy mutatószám). A pusztán hivatkozási célú anyagok, mint az irányelvek, ezzel szemben a „Dokumentumok” közé tartoznak.",
    "helpers": "Segítők",
    "helpersHint": "Mivel és kivel végzi el ezt a lépést? A használt rendszerek, a kötelezően bevont személyek és funkciók, valamint a szükséges dokumentumok.",
    "persons": "Személy(ek)",
    "teams": "Funkció(k)",
    "systems": "Rendszer(ek)",
    "documents": "Dokumentum(ok)",
    "successors": "Utódok",
    "noSuccessors": "A folyamat itt ér véget",
    "unclearSuccessors": "Nem egyértelmű folytatás",
    "pendingSystem": "Javasolt rendszer",
    "pendingOrgFunction": "Javasolt funkció",
    "decisionRules": "Döntési szabályok",
    "whoElseDoesThis": "Ki csinálja még ezt",
    "whoElseDoesThisDescription": "Válassza ki azokat a személyeket, akik Öntől függetlenül átvehetnék ezt a lépést – pl. helyettesként. Több is megadható.",
    "whoElseDoesThisDescriptionEditor": "Személyek, akik szintén végzik ezt a lépést – pl. helyettesként. Több is megadható.",
    "status": {
      "pending": "Függőben",
      "accepted": "Elfogadva",
      "declined": "Elutasítva"
    },
    "feedback": "Visszajelzés",
    "variantCheck": {
      "title": "Változatellenőrzés",
      "same": "pontosan így",
      "different": "másképp",
      "notPerformed": "nem végzi",
      "viewVariants": "Változatok megtekintése"
    },
    "createdAt": "Létrehozva",
    "updatedAt": "Frissítve",
    "completedAt": "Befejezve",
    "noStepsRecorded": "Még nincsenek rögzített folyamatlépések",
    "startRecordingHint": "Indítson rögzítést a folyamatábra megtekintéséhez",
    "output": "Kimenet",
    "expandTable": "Táblázat nagyítása",
    "endLabel": "Vége",
    "noFurtherSteps": "Nincs további lépés",
    "unclearContinuation": "Tisztázatlan folytatás",
    "swimlane": {
      "unassigned": "Nincs hozzárendelve"
    },
    "viralPlaceholder": {
      "pending": "Felvételre várva",
      "accepted": "Felvétel folyamatban",
      "pendingUnclear": "Tisztázatlan — vár a folyamat tulajdonosának megoldására",
      "proposed": "Javasolt — jóváhagyásra vár",
      "declined": "Javasolt — elutasítva"
    },
    "editable": {
      "noAssignee": "Nincs felelős",
      "addInput": "Bemenet hozzáadása",
      "reorderInput": "Húzza az átrendezéshez",
      "removeInput": "Bemenet eltávolítása",
      "addHelper": "Segítő hozzáadása",
      "addArtifact": "Új dokumentum hozzáadása",
      "noSuccessors": "Nincs beállított utód",
      "addSuccessor": "Utód hozzáadása",
      "removeSuccessor": "Utód eltávolítása",
      "noDecisionRules": "Nincsenek döntési szabályok",
      "editDecisionRules": "Döntési szabályok szerkesztése",
      "noHelpers": "Nincs kiválasztott segítő",
      "editHelpers": "Segítők szerkesztése",
      "editHelpersDescription": "Válassza ki azokat a személyeket, funkciókat és rendszereket, amelyek segítenek ebben a lépésben.",
      "none": "Nincs",
      "personsCount": "{{count}} személy",
      "personsCount_one": "{{count}} személy",
      "personsCount_other": "{{count}} személy",
      "teamsCount": "{{count}} funkció",
      "teamsCount_one": "{{count}} funkció",
      "teamsCount_other": "{{count}} funkció",
      "systemsCount": "{{count}} rendszer",
      "systemsCount_one": "{{count}} rendszer",
      "systemsCount_other": "{{count}} rendszer",
      "documentsCount": "{{count}} dokumentum",
      "documentsCount_one": "{{count}} dokumentum",
      "documentsCount_other": "{{count}} dokumentum"
    },
    "contextMenu": {
      "addStep": "Lépés hozzáadása",
      "addEvent": "Esemény hozzáadása",
      "addEventForStep": "Esemény hozzáadása a lépéshez",
      "editStep": "Lépés szerkesztése",
      "deleteStep": "Lépés törlése",
      "editEvent": "Esemény szerkesztése",
      "deleteEvent": "Esemény törlése",
      "markAsEnd": "Jelölés végponként",
      "markUnclear": "Jelölés tisztázatlanként",
      "convertToAssignment": "Átalakítás megbízássá",
      "convertToStep": "Átalakítás lépéssé",
      "mergeNode": "Egyesítés ezzel…",
      "mergeDisabledHasSuccessor": "Csak utód nélküli lépéseket lehet egyesíteni",
      "insertBetween": "Lépés beszúrása közé",
      "forkFromSource": "Párhuzamos ág megnyitása",
      "mergeIntoTarget": "Párhuzamos ág egyesítése",
      "deleteEdge": "Törlés",
      "saveAsStepTemplate_one": "Mentés lépéssablonként ({{count}} elem)",
      "saveAsStepTemplate_other": "Mentés lépéssablonként ({{count}} elem)",
      "insertStepTemplate": "Beszúrás lépéssablonból"
    },
    "mergeDialog": {
      "title": "Lépések egyesítése",
      "description": "Válasszon egy másik lépést az egyesítéshez, majd válassza ki, melyik lépés maradjon meg.",
      "selectCandidate": "Egyesítendő lépés",
      "searchCandidates": "Lépések keresése…",
      "noCandidates": "Nincs másik egyesíthető lépés",
      "unnamedNode": "Névtelen lépés",
      "assignedTo": "Hozzárendelve: {{name}}",
      "survivorLabel": "Melyik lépés maradjon meg?",
      "keepSource": "„{{name}}” megtartása",
      "keepTarget": "„{{name}}” megtartása",
      "resultKindStep": "Az eredmény egy lépés lesz.",
      "resultKindAssignment": "Az eredmény egy megbízás lesz.",
      "confirm": "Egyesítés",
      "cancel": "Mégse"
    },
    "detailPanel": {
      "dragToMove": "Húzd a mozgatáshoz (kattints duplán a visszaállításhoz)",
      "dragToResize": "Húzd az átméretezéshez"
    }
  },
  "processDetail": {
    "editProcess": "Folyamat szerkesztése",
    "export": {
      "title": "Folyamat exportálása",
      "button": "Exportálás",
      "description": "Válassza ki, mely szakaszok kerüljenek be a letöltött JSON-fájlba.",
      "steps": "Lépések",
      "assignments": "Hozzárendelések",
      "capacity": "Kapacitás (érzékeny)",
      "context": "Szervezeti kontextus (szerepkörök, részlegek, rendszerek, csapatok, szervezeti ábra)",
      "format": "Formátum",
      "formatJson": "JSON",
      "formatYaml": "YAML",
      "formatExcel": "Excel",
      "includeMetrics": "Mutatószámok megjelenítése (Értékelés, Gyakoriság, Időtartam, Kapacitáslekötés)",
      "download": "Letöltés",
      "cancel": "Mégse",
      "success": "Folyamat exportálva",
      "error": "A folyamat exportálása sikertelen",
      "capacitySource": "Kapacitásforrás",
      "capacitySourceSurvey": "felmért",
      "capacitySourceManual": "kézzel rögzítve"
    }
  },
  "processFlowEditor": {
    "newTask": "Új feladat",
    "newDecision": "Új döntés",
    "emptyNote": "Üres jegyzet",
    "noteLink": "Összekapcsolás lépésekkel",
    "noteLinkHint": "Kattintson a lépésekre az összekapcsoláshoz vagy leválasztáshoz · kattintson üres területre a befejezéshez",
    "noteCategory": {
      "context": "Kontextus",
      "problem": "Probléma",
      "question": "Kérdés",
      "todo": "Teendő"
    },
    "ruleNoOutput": "A szabálynak nincs kimenő kapcsolata vagy záró állapota",
    "eventDisconnected": "Az eseménynek nincs kimenő kapcsolata",
    "sendInvitations": "Meghívók küldése",
    "noInvitations": "Nincs küldendő meghívó",
    "sendAll": "Összes küldése",
    "savePositions": "Pozíciók mentése",
    "pendingInvitations": "Függő meghívók ({{count}})",
    "swimlane": {
      "moveUp": "Sáv feljebb",
      "moveDown": "Sáv lejjebb",
      "color": "Sáv színe",
      "resetColor": "Szín visszaállítása",
      "customColorPlaceholder": "#RRGGBB",
      "applyColor": "Alkalmaz"
    }
  },
  "processDraft": {
    "preparing": "Piszkozat előkészítése...",
    "loadError": "A piszkozat nem tölthető be.",
    "refetchErrorBanner": "A módosítások jelenleg nem kerülnek mentésre — kapcsolati vagy munkamenet-probléma. Kérjük, töltse újra az oldalt.",
    "draftBadge": "Piszkozat",
    "lastSaved": "Mentve {{when}}",
    "publish": "Közzététel",
    "discard": "Piszkozat eldobása",
    "discardConfirm": "Módosítások eldobása?",
    "addStep": "Lépés hozzáadása",
    "addNote": "Jegyzet hozzáadása",
    "stepDetail": "Lépés",
    "assigneeSet": "Felelős kiválasztva",
    "assigneeNone": "Nincs felelős",
    "pickAssignee": "Felelős kiválasztása",
    "pickActionType": "Válassz típust.",
    "needsInput": "Bemenet szükséges",
    "decisionEditNotice": "A döntési szabályok közzététel után szerkeszthetők.",
    "taskDescription": "Feladat leírása",
    "taskDescriptionPlaceholder": "Mi történik ebben a lépésben?",
    "confirmDeleteStep": "Töröljük a lépést a piszkozatból?",
    "confirmDisconnect": "Eltávolítjuk a kapcsolatot?",
    "editor": {
      "generateWithAi": "Generálás AI-val",
      "generateWithAiDisabled": "Először adj meg bemeneteket, feladatleírást vagy szabályokat",
      "generateWithAiError": "A lépésösszefoglaló generálása nem sikerült",
      "descriptionPlaceholder": "Foglalja össze ezt a lépést…"
    },
    "mode": {
      "manual": "Manuális",
      "viral": "Virális",
      "viralDisabledReason": "Csak olyan levél lépés válhat virális megbízássá, amelynek van forrás előző lépése."
    },
    "surveys": {
      "heading": "Felmérések",
      "reRequestToggleLabel": "Felmérés újrakérése közzétételkor",
      "reRequestToggleHint": "Közzétételkor a lépés résztvevőit ismét felkérjük a felmérésük kitöltésére.",
      "publishReRequestAll": "Közzététel és összes felmérés újrakérése",
      "reRequestShort": "Újrakérés",
      "reRequestShortActive": "Újrakérés ütemezve",
      "status": {
        "pending": "Függőben",
        "completed": "Kész",
        "dismissed": "Nem végzi a lépést",
        "toCreate": "Létrejön",
        "invited": "Meghívva"
      },
      "variantStatus": {
        "pending": "Változatellenőrzés függőben",
        "answered": "Változatellenőrzés megválaszolva",
        "notApplicable": "Nincs változatellenőrzés"
      },
      "statusNone": "Még nincsenek felmérések"
    },
    "unclearSuccessor": {
      "label": "Tisztázatlan folytatás"
    },
    "actionTypeHint": "Írja le, mi történik ebben a lépésben. Ha szokásos feladatról van szó, válassza a „Tevékenység” lehetőséget. Ha a folytatás feltételektől függ (pl. jóváhagyva/elutasítva), válassza a „Döntés” lehetőséget.",
    "actionType": {
      "task": "Tevékenység",
      "decision": "Döntés"
    },
    "card": {
      "unconfigured": "Nincs beállítva",
      "taskLabel": "Feladat (leírás nélkül)",
      "decisionLabel": "Döntés (szabályok nélkül)",
      "assigned": "Hozzárendelve",
      "pickAssignee": "Felelős",
      "needsInput": "Bemenet kell",
      "willInvite": "Meghívás várható"
    },
    "graphReason": {
      "no-inputs": "Nincs bemenete",
      "no-outputs": "A lépésnek nincs utódja",
      "orphan": "Nincs csatlakoztatva",
      "no-start-event": "A folyamatnak nincs kezdőeseménye — nyisd meg újra a szerkesztőt a helyreállításához",
      "event-disconnected": "Az eseménynek nincs kimenő kapcsolata",
      "event-disconnected-named": "A(z) „{{name}}\" eseménynek nincs kimenő kapcsolata",
      "rule-no-output": "A(z) „{{output}}\" szabálynak nincs kimenő kapcsolata vagy záró állapota",
      "rule-no-output-unnamed": "Egy döntési szabálynak nincs kimenő kapcsolata vagy záró állapota",
      "unreachable": "A lépés le van vágva a folyamat többi részétől",
      "unreachable-named": "A(z) „{{name}}\" esemény le van vágva a folyamat többi részétől"
    },
    "publishErrors": {
      "title": "Közzététel akadálya",
      "goToStep": "Ugrás a lépéshez",
      "unnamedStep": "Névtelen lépés",
      "unnamedEvent": "Névtelen esemény",
      "processLevel": "Folyamat",
      "fieldLabels": {
        "actionType": "Lépés típusa",
        "taskDescription": "Feladat leírása",
        "output": "Eredmény szöveg",
        "rules": "Szabályok",
        "assignedTo": "Felelős",
        "inputs": "Bemenetek",
        "helpers": "Segítők",
        "helperPersons": "Segítők (személyek)",
        "helperOrgFunctions": "Segítők (funkciók)",
        "helperSystems": "Segítők (rendszerek)",
        "helperDocuments": "Segítők (dokumentumok)",
        "whoElseDoesThis": "További résztvevők",
        "generatedName": "Lépés neve",
        "generatedDescription": "Lépés leírása",
        "manualCapacity": "Kézzel rögzített kapacitás"
      },
      "issueMessages": {
        "actionTypeRequired": "A lépés típusa kötelező",
        "taskDescriptionRequired": "A feladat leírása kötelező",
        "taskOutputRequired": "Az eredmény szövege kötelező",
        "rulesRequired": "Legalább egy döntési szabály szükséges",
        "ruleOutputRequired": "A szabály eredménye kötelező",
        "ruleConditionRequired": "A szabálynak legalább egy kitöltött feltételértékre van szüksége",
        "stepAssigneeRequired": "A lépéshez felelős szükséges",
        "assignmentAssigneeRequired": "A hozzárendeléshez felelős szükséges",
        "assignmentInputRequired": "A hozzárendeléshez legalább egy bemenet szükséges egy megelőző lépésből",
        "eventNameRequired": "Az esemény neve kötelező",
        "startEventDescriptionRequired": "Az indító esemény leírása kötelező"
      }
    },
    "draftConflict": {
      "title": "A szerkesztői módosítások és a decentralizált felvétel ütközik",
      "body": "A decentralizált felvétel során olyan folyamatlépéseket rögzítettek, amelyek a szerkesztő legutóbbi, közzé nem tett állapotától eltérő folyamatmenetet jelenítenek meg.",
      "yours": "Szerkesztői vázlat",
      "live": "Decentralizált felvétel",
      "listEmpty": "(nincs)",
      "unnamedItem": "(névtelen)",
      "cancel": "Szerkesztői vázlat megtartása (a decentralizált felvétel állapota felülíródik)",
      "discard": "Szerkesztői vázlat elvetése (a decentralizált felvétel állapota a helyes)",
      "discardModalTitle": "Elveti a szerkesztői vázlatot?",
      "discardModalBody": "Ez véglegesen törli a teljes szerkesztői vázlatot — minden módosítást az összes lépésben, nem csak ebben. A vázlat újra létrejön a decentralizált felvétel aktuális állapotából. Ez a művelet nem visszavonható.",
      "discardModalCancel": "Szerkesztői vázlat megtartása",
      "discardModalConfirm": "Szerkesztői vázlat elvetése",
      "publishAnyway": "Szerkesztői vázlat megtartása (a decentralizált felvétel állapota felülíródik)",
      "publishAnywayModalTitle": "Felülírja a decentralizált felvételt?",
      "publishAnywayModalBody": "Az aktuális decentralizált felvétel állapotát felülírja a szerkesztői vázlatával. A folyamatban lévő decentralizált felvételek — a nyitott meghívók — elveszhetnek vagy érvénytelenné válhatnak. Ez a művelet nem visszavonható.",
      "publishAnywayModalCancel": "Vissza",
      "publishAnywayModalConfirm": "Felülírás",
      "unnamedStep": "Névtelen lépés",
      "empty": "A lépést külsőleg módosították",
      "changesCount_one": "{{count}} módosítás",
      "changesCount_other": "{{count}} módosítás"
    },
    "publishUnknownError": "A közzététel sikertelen — próbálja újra.",
    "invitesFailedToast_one": "A vázlat közzétételre került, de {{count}} meghívót nem sikerült elküldeni. Az érintett címzetteket újra meg kell hívni.",
    "invitesFailedToast_other": "A vázlat közzétételre került, de {{count}} meghívót nem sikerült elküldeni. Az érintett címzetteket újra meg kell hívni.",
    "issues": {
      "count_one": "{{count}} probléma",
      "count_other": "{{count}} probléma",
      "title": "Közzététel előtt",
      "none": "Nincs probléma",
      "kinds": {
        "actionType": {
          "title": "Hiányzik a lépés típusa"
        },
        "taskDescription": {
          "title": "Hiányzik a feladat leírása"
        },
        "output": {
          "title": "Hiányzik a kimenet"
        },
        "assignee": {
          "title": "Nincs felelős"
        },
        "rules": {
          "title": "Nincs döntési szabály"
        },
        "ruleOutput": {
          "title": "{{number}}. szabály: hiányzik a kimenet"
        },
        "ruleCondition": {
          "title": "{{number}}. szabály: hiányzik a feltétel"
        },
        "assignmentInput": {
          "title": "Nincs bemenet",
          "hint": "Kössön egy megelőző lépést ehhez a helyőrzőhöz."
        },
        "eventName": {
          "title": "Hiányzik az esemény neve"
        },
        "eventDescription": {
          "title": "Hiányzik a leírás"
        },
        "noInputs": {
          "title": "Nincs bemenet",
          "hint": "Húzzon ide egy kapcsolatot egy megelőző lépésből."
        },
        "noOutputs": {
          "title": "Nincs utód",
          "hint": "Kössön hozzá egy következő lépést, vagy jelölje meg a lépést végpontként."
        },
        "decisionNoOutputs": {
          "title": "Egyik szabálynak sincs célja",
          "hint": "Kösse össze mindegyik szabályt egy lépéssel, vagy jelölje meg végpontként."
        },
        "orphan": {
          "title": "Nincs csatlakoztatva",
          "hint": "Kösse be a lépést a folyamatba – vagy törölje."
        },
        "ruleNoOutput": {
          "title": "A(z) „{{output}}” szabálynak nincs célja",
          "titleUnnamed": "Egy szabálynak nincs célja",
          "hint": "Kösse össze a szabályt egy lépéssel, vagy jelölje meg végpontként."
        },
        "eventDisconnected": {
          "title": "Az esemény nincs csatlakoztatva",
          "hint": "Kösse össze az eseményt azzal a lépéssel, amelyet kivált."
        },
        "unreachable": {
          "title": "Le van vágva a folyamatról",
          "hint": "Kösse össze ezt a részt a folyamat többi részével."
        },
        "noStartEvent": {
          "title": "Nincs kezdőesemény",
          "hint": "Nyissa meg újra a szerkesztőt a helyreállításához."
        }
      }
    },
    "startEvent": {
      "title": "Indító esemény",
      "titleHint": "Egy folyamat minden indító eseménye egy tevékenységhez vezet, amely az Ön vállalatánál zajlik. Adja meg, ki végzi el ezt a tevékenységet, valahányszor az indító esemény bekövetkezik.",
      "eventTypeLabel": "Kiváltó esemény",
      "eventTypeHint": "A kiváltó esemény határozza meg, mi indítja el a folyamatot.\n\nKézi indítás = Egy személy aktívan elindítja a folyamatot.\nBeérkező kérés = Egy e-mail, egy kérelem vagy egy másik rendszer stb. indítja el a folyamatot.\nIdőpont / Határidő = A folyamat egy adott időpontban vagy ismétlődően indul el (pl. havonta).",
      "nameLabel": "Név",
      "descriptionLabel": "Leírás",
      "namePlaceholder": "Mi indítja el ezt a folyamatot?",
      "descriptionPlaceholder": "Írja le, mi váltja ki ezt az eseményt (pl. egy munkatárs szabadságkérelmet nyújt be)",
      "assigneeCardSubtitle": "Válassza ki, ki vagy mi dolgozik tovább az indító eseménnyel",
      "assigneeCardHelper": "Az indító eseményt egy vagy több személyhez, funkcióhoz (szerepkörökhöz vagy csapatokhoz) vagy rendszerhez rendelheti."
    },
    "event": {
      "title": "Esemény",
      "eventTypeLabel": "Esemény típusa",
      "nameLabel": "Név",
      "descriptionLabel": "Leírás",
      "namePlaceholder": "Mit jelent ez az esemény?",
      "descriptionPlaceholder": "Írja le az eseményt"
    },
    "capacity": {
      "title": "Kapacitás",
      "enter": "Kézi rögzítés",
      "shadowHint": "kézzel rögzítve — a felmért érték élvez elsőbbséget",
      "excludedBySettingHint": "kézzel rögzítve — a „Kapacitásforrás” beállítás kizárja a kézi értékeket",
      "dialogTitle": "Kapacitás kézi rögzítése",
      "frequency": "Gyakoriság",
      "timesPerPeriod": "Darabszám",
      "duration": "Időtartam (perc)",
      "preview": "≈ {{month}} ó/hónap · {{year}} ó/év személyenként — a felmérési válaszhoz hasonlóan a csapatra vetítve",
      "previewPerPerson": "≈ {{month}} ó/hónap · {{year}} ó/év személyenként",
      "previewTeamTotal": "× {{count}} csapattag ≈ {{month}} ó/hónap · {{year}} ó/év összesen",
      "previewTotal": "≈ {{month}} ó/hónap · {{year}} ó/év összesen",
      "attribution": "kézzel rögzítette: {{name}}, {{date}}",
      "remove": "Eltávolítás",
      "primitives": "{{frequency}} · {{minutes}} perc",
      "saveError": "A kapacitás mentése nem sikerült."
    }
  },
  "processes": {
    "title": "Folyamatok",
    "description": "A szervezet összes folyamatának áttekintése",
    "search": "Folyamatok keresése...",
    "createProcess": "Folyamat létrehozása",
    "editDetails": "Részletek szerkesztése",
    "createProcessDescription": "Új folyamat hozzáadása a szervezethez",
    "editProcessDescription": "A folyamat adatainak frissítése",
    "empty": "Nem található folyamat",
    "nameLabel": "Folyamat neve",
    "owner": "Tulajdonos",
    "ownerPlaceholder": "Folyamattulajdonos kiválasztása",
    "accountableClearLabel": "Alapértelmezett (osztályvezető)",
    "accountablePlaceholder": "Nincs kiválasztva senki",
    "department": "Osztály",
    "departmentPlaceholder": "Osztály kiválasztása",
    "ownerAndDepartmentEditHint": "Lépjen kapcsolatba a szervezet vezetőjével az osztály vagy a folyamattulajdonos megváltoztatásához",
    "namePlaceholder": "Adja meg a folyamat nevét, pl. Szabadságkérelem beadása",
    "descriptionPlaceholder": "Adja meg a folyamat leírását, pl. „A folyamat leírja egy szabadságkérelem menetét a beadástól a jóváhagyásig”",
    "category": "Folyamatkategória",
    "categoryPlaceholder": "Kategória kiválasztása",
    "notFound": "Folyamat nem található",
    "detailDescription": "Folyamat részleteinek megtekintése és kezelése",
    "details": "Folyamat részletei",
    "totalSteps": "Összes lépés",
    "stepCount": "Lépések",
    "stepsCount_one": "{{count}} lépés",
    "stepsCount_other": "{{count}} lépés",
    "draftEdited": "Szerkesztve: {{when}}",
    "draftEditedBy": "Szerkesztette: {{name}}, {{when}}",
    "recordedHeader": "Rögzítve",
    "recordedTooltip": "rögzített lépések / összes ismert lépés",
    "averageRating": "Értékelés",
    "rating": "Értékelés",
    "Accountable": "Felelős",
    "ProcessOwner": "Folyamattulajdonos",
    "involvedEntities": "Érintett entitások",
    "involvedPeople": "Személyek",
    "involvedTeams": "Csapatok",
    "involvedFunctions": "Funkciók",
    "usedSystems": "Rendszerek",
    "usedArtifacts": "Dokumentumok",
    "externalContacts": "Külső kapcsolatok",
    "usageAssigned": "Hozzárendelve",
    "usageRecorded": "Rögzítette",
    "usageWhoElseDoesThis": "Ki csinálja még",
    "usageHelper": "Segítő itt:",
    "noInvolvedPeople": "Nincsenek érintett személyek",
    "noUsedSystems": "Nincsenek használt rendszerek",
    "noUsedArtifacts": "Nincsenek használt dokumentumok",
    "noExternalContacts": "Nincsenek érintett külső kapcsolatok",
    "processSteps": "Folyamatlépések",
    "processStep": "Folyamatlépés",
    "stepNumber": "Lépés #",
    "successorNumber": "Következő lépés #",
    "successor": "Következő lépés",
    "branches": "Elágazások",
    "stepsSheet": "Lépések",
    "frequencyLabel": "Gyakoriság",
    "duration": "Időtartam",
    "inputs": "Bemenetek",
    "output": "Kimenet",
    "processStepMembers": "Folyamatlépés személyei",
    "helperSystems": "Segítők (Rendszerek)",
    "helperPersons": "Segítők (Személyek)",
    "helperOrgFunctions": "Segítők (Funkciók)",
    "helperDocuments": "Segítők (Dokumentumok)",
    "lastChange": "Utolsó módosítás",
    "variants": "Variánsok",
    "capacityBinding": "Kapacitáslekötés",
    "responseCoverage": "Konfidencia: a várt válaszadók közül {{percent}} válaszolt",
    "noSteps": "Nem találhatók folyamatlépések",
    "minutesValue": "{{value}}p",
    "stepRecordedBy": "Lépést rögzítette: {{name}}",
    "frequency": {
      "weekly": "Hetente",
      "daily": "Naponta",
      "monthly": "Havonta",
      "multiple-times-daily": "Naponta többször",
      "once-a-day": "Naponta egyszer",
      "several-times-a-week": "Hetente többször",
      "once-per-week": "Hetente egyszer",
      "every-two-weeks": "Kéthetente",
      "every-three-weeks": "Háromhetente",
      "quarterly": "Negyedévente",
      "semi-annually": "Félévente",
      "yearly": "Évente",
      "timesSuffix": " ({{count}}×)"
    },
    "statusNotStarted": "Nem indult el",
    "statusInProgress": "Folyamatban",
    "statusCompleted": "Befejezve",
    "statusRecordingComplete": "Felvéve",
    "pendingSurveyCount_one": "{{count}} nyitott felmérés",
    "pendingSurveyCount_other": "{{count}} nyitott felmérés",
    "deleteConfirmDescription": "Biztosan törli ezt a folyamatot? Ez a művelet nem vonható vissza.",
    "duplicateTitle": "Folyamat duplikálása",
    "duplicateDescription": "Készítsen másolatot a(z) \"{{name}}\" folyamatról a rögzített lépésekkel, hozzárendelésekkel, jegyzetekkel és elrendezéssel együtt.",
    "duplicateNameDefault": "{{name}} (másolat)",
    "duplicateSuccess": "A folyamat sikeresen duplikálva",
    "duplicateFailed": "A folyamat duplikálása nem sikerült",
    "incompleteStep": "Folyamatban",
    "type": "Típus",
    "task": "Feladat",
    "decision": "Döntés",
    "decisionWithRules": "Döntés: {{count}} szabály",
    "conditions": "Feltételek",
    "stepDescription": "Lépés leírása",
    "pendingAssignments": "Függőben lévő hozzárendelések",
    "assignedTo": "Felelős",
    "assignedBy": "Hozzárendelő",
    "sourceStep": "Forrás lépés",
    "status": "Státusz",
    "assignedDate": "Hozzárendelés dátuma",
    "noPendingAssignments": "Nincsenek függőben lévő hozzárendelések",
    "processStart": "Folyamat kezdete",
    "assignmentStatus": {
      "pending": "Függőben",
      "accepted": "Elfogadva",
      "rejected-reassigned": "Elutasítva - Átadva",
      "rejected-unclear": "Elutasítva - Nem egyértelmű",
      "pending-unclear": "Függőben - Nem egyértelmű",
      "unclear-reassigned": "Nem egyértelmű - Átadva"
    },
    "createProcessesPage": {
      "title": "Folyamatok létrehozása",
      "description": "Adjon hozzá folyamatokat a folyamatvilágához. Vagy manuálisan hozza létre őket, vagy Excelből tölti fel.",
      "editProcessDescription": "A folyamat adatainak frissítése",
      "addManually": "Manuális hozzáadás",
      "addManuallyDescription": "Folyamat létrehozása az űrlap segítségével",
      "uploadFromExcel": "Feltöltés Excelből",
      "uploadFromExcelDescription": "Több folyamat importálása Excel fájlból",
      "draftProcesses": "Vázlat folyamatok",
      "noDrafts": "Még nincsenek vázlat folyamatok. Adjon hozzá folyamatokat, hogy hivatalosan létrehozza őket a BLIKS IO-ban.",
      "createAll": "Összes folyamat létrehozása",
      "cancel": "Mégse",
      "uploadSuccess_one": "{{count}} folyamat sikeresen hozzáadva Excelből",
      "uploadSuccess_other": "{{count}} folyamat sikeresen hozzáadva Excelből",
      "editProcessTitle": "Folyamat szerkesztése",
      "confirmDelete": "Biztosan törli ezt a folyamatot? Ez a művelet nem vonható vissza.",
      "successCreated_one": "{{count}} folyamat sikeresen létrehozva",
      "successCreated_other": "{{count}} folyamat sikeresen létrehozva",
      "validationErrors": "Érvényesítési hibák",
      "fixErrorsWarning": "Kérjük, javítsa az érvényesítési hibákat a folyamatok létrehozása előtt",
      "noDepartmentHead": "A kiválasztott osztálynak nincs osztályvezetője."
    },
    "capacitySourceSurvey": "Felmért",
    "capacitySourceManual": "Kézi",
    "capacityManualMark": "kézzel rögzítve",
    "capacityEffective": "érvényes",
    "capacityIncludesManual": "kézi értékeket tartalmaz",
    "capacityConfidence": "Megbízhatóság: {{percent}}"
  },
  "stepRecording": {
    "confirmReassign": {
      "title": "Átadás megerősítése",
      "description": "A jelenlegi haladása véglegesen törlődik. Biztosan át szeretné adni ezt a feladatot?",
      "assigneeLabel": "Átadás neki",
      "unclearBody": "Ez a feladat tisztázatlanként lesz megjelölve, és a folyamat tulajdonosához kerül."
    },
    "reassignSuccess": "Feladat sikeresen átadva",
    "reassignError": "Nem sikerült a feladat átadása. Kérjük, próbálja újra.",
    "reassignMissingInfo": "Nem lehet átadni: hiányzó rögzítési információ",
    "finishError": "Nem sikerült a rögzítés befejezése",
    "stopError": "Nem sikerült a rögzítés leállítása",
    "resumeError": "Nem sikerült visszatérni a szerkesztéshez",
    "retryError": "Nem sikerült újragenerálni az összefoglalót",
    "review": {
      "title": "Lépés ellenőrzése",
      "subtitle": "Fogadja el az MI javaslatát, vagy szerkessze az egyes mezőket a ceruza ikonnal.",
      "subtitleManual": "Adjon meg egy címet és leírást ehhez a lépéshez.",
      "titlePlaceholder": "Adjon meg egy címet",
      "descriptionPlaceholder": "Adjon meg egy leírást",
      "titleLabel": "Cím",
      "descriptionLabel": "Leírás",
      "back": "Vissza a szerkesztéshez",
      "apply": "Alkalmaz",
      "editTitle": "Cím szerkesztése",
      "editDescription": "Leírás szerkesztése",
      "confirmEdit": "Módosítás megerősítése",
      "cancelEdit": "Módosítás elvetése",
      "generating": "Összefoglaló készítése…",
      "generatingBanner": "A Bliksy készíti a lépés összefoglalóját…",
      "bliksySuggestion": "Bliksy javaslata",
      "failed": "Az összefoglaló elkészítése sikertelen.",
      "retry": "Próbálja újra",
      "regenerate": "MI-összefoglaló újragenerálása",
      "aiError": "Az MI-összefoglaló generálása sikertelen. Próbálja újra az újragenerálás gombbal, vagy töltse ki a mezőket kézzel."
    }
  },
  "processMap": {
    "title": "Folyamattérkép",
    "empty": "Még nincsenek folyamatok. Hozzon létre folyamatokat a térkép felépítéséhez",
    "kpi": {
      "total": "Folyamatok",
      "core": "Alapfolyamatok",
      "management": "Vezetési folyamatok",
      "support": "Támogató folyamatok",
      "connections": "Összekapcsolt folyamatok",
      "isolated": "Elszigetelt folyamatok"
    },
    "lanes": {
      "management": "Vezetés",
      "core": "Alapfolyamatok",
      "support": "Támogató",
      "uncategorized": "Nem kategorizált"
    },
    "uncategorizedHint": "{{count}} folyamat még nincs kategorizálva. Rendeljen hozzájuk kategóriát (Alap/Vezetési/Támogató) a térkép strukturálásához.",
    "editorMode": "Szerkesztés",
    "resetLayout": "Elrendezés visszaállítása",
    "resetLayoutConfirm": "Minden manuális pozíció visszaáll az automatikus elrendezésre. Folytatja?",
    "saveChanges": "Mentés",
    "discardChanges": "Elvetés",
    "tooltip": {
      "connected": "Kapcsolódik",
      "notConnected": "Nem kapcsolódik",
      "from": "Honnan",
      "to": "Hova",
      "outputLabel": "Kimenet",
      "startEventLabel": "Kezdő esemény"
    },
    "departmentFilter": {
      "placeholder": "Osztályok",
      "search": "Osztályok keresése...",
      "empty": "Nem található osztály",
      "selected": "{{count}} osztály",
      "modeHighlight": "Kiemelés mód: elhalványítja a nem illeszkedő folyamatokat",
      "modeFilter": "Szűrő mód: elrejti a nem illeszkedő folyamatokat"
    },
    "search": {
      "placeholder": "Folyamatok keresése...",
      "noResults": "Nincs találat"
    },
    "chainFilter": {
      "placeholder": "Folyamatláncok",
      "search": "Lánc keresése...",
      "empty": "Nincsenek folyamatokat tartalmazó láncok",
      "selected": "{{count}} lánc",
      "modeHighlight": "Kiemelés mód: elhalványítja a nem illeszkedő folyamatokat",
      "modeFilter": "Szűrő mód: elrejti a nem illeszkedő folyamatokat"
    },
    "editorHints": {
      "dragNode": "Folyamat mozgatása",
      "selectArea": "Terület kijelölése",
      "pan": "Nézet mozgatása",
      "multiSelect": "Hozzáadás a kijelöléshez",
      "clickPort": "Kapcsolat létrehozása",
      "leftClick": "Bal",
      "rightClick": "Jobb",
      "shift": "Shift",
      "dragOnNode": "Húzás a folyamaton",
      "dragOnCanvas": "Húzás a vásznon"
    },
    "connectDialog": {
      "title": "Összekapcsolás létrehozása",
      "description": "Létre szeretné hozni az összekapcsolást?",
      "duplicateTitle": "A kapcsolat már létezik",
      "duplicateDescription": "Ez a kapcsolat már létezik a kiválasztott portok között.",
      "duplicateWarning": "Azonos kapcsolat már létezik. Nem hozható létre újra.",
      "confirm": "összekapcsolás"
    },
    "focusBadge": "Focus: {{name}}",
    "miniMap": {
      "title": "Folyamatáramlás",
      "showInLandscape": "Megjelenítés a térképen",
      "noConnections": "Nincsenek kapcsolatok"
    }
  },
  "connections": {
    "title": "Kapcsolatok",
    "noConnections": "Ennek a folyamatnak még nincsenek kapcsolatai",
    "predecessors": "Előzmények",
    "successors": "Következmények",
    "unconnectedPorts": "Nem kapcsolt portok",
    "notConnected": "Nem kapcsolódik",
    "addPredecessor": "Előd hozzáadása",
    "addSuccessor": "Utód hozzáadása",
    "assignConnection": "Hozzárendelés",
    "deleteConnection": "Kapcsolat törlése",
    "deleteConnectionConfirm": "Biztosan törölni szeretné ezt a kapcsolatot?",
    "manageConnections": {
      "title": "Kapcsolatok kezelése: {{portName}}",
      "description": "Válasszon folyamatokat és portjaikat a kapcsolatok létrehozásához.",
      "inputLabel": "Forrásfolyamatok és outputjaik",
      "outputLabel": "Célfolyamatok és inputjaik",
      "save": "Mentés",
      "saving": "Mentés folyamatban...",
      "saveFailed": "A kapcsolatok mentése sikertelen"
    }
  },
  "portConnectionSelector": {
    "searchPlaceholder": "Folyamat keresése...",
    "selectedCount": "{{count}} folyamat kiválasztva",
    "noInputs": "Nincsenek elérhető inputok",
    "noOutputs": "Nincsenek elérhető outputok",
    "allDepartments": "Összes osztály",
    "outputCount": "{{count}} output(ok)",
    "inputCount": "{{count}} input(ok)"
  },
  "processChains": {
    "title": "Folyamatláncok",
    "createChain": "Új folyamatlánc",
    "categories": {
      "management": "Vezetés",
      "core": "Alap",
      "support": "Támogató"
    },
    "empty": {
      "title": "Nem találhatók folyamatláncok",
      "description": "Hozzon létre folyamatláncokat a folyamatok végponttól végpontig tartó munkafolyamatokba rendezéséhez."
    },
    "createDialog": {
      "name": "Lánc neve",
      "namePlaceholder": "pl. „Order-to-Cash”",
      "description": "Leírás",
      "descriptionPlaceholder": "A folyamatlánc rövid leírása (opcionális)",
      "category": "Folyamatlánc kategória"
    },
    "editChain": {
      "title": "Folyamatlánc szerkesztése",
      "description": "A folyamatlánc nevének, leírásának és kategóriájának módosítása."
    },
    "edit": {
      "button": "Szerkesztés",
      "title": "Lánc folyamatainak kezelése",
      "description": "Folyamatok hozzáadása, eltávolítása vagy átrendezése ebben a láncban.",
      "addProcess": "Folyamat hozzáadása...",
      "noProcesses": "Még nincsenek hozzárendelt folyamatok",
      "addProcesses": "Folyamatok hozzáadása",
      "swimlane": {
        "strategic": "Stratégiai",
        "core": "Alap",
        "support": "Támogató"
      },
      "remove": "Eltávolítás",
      "autoDetect": {
        "button": "Automatikus felismerés",
        "title": "Folyamatlánc automatikus felismerése",
        "description": "Válasszon egy kezdő folyamatot. Az összes összekapcsolt folyamat automatikusan felismerésre kerül",
        "selectSeed": "Kezdő folyamat kiválasztása...",
        "detected": "{{count}} folyamat felismerve",
        "addAll": "Összes hozzáadása a lánchoz",
        "noConnections": "Ennek a folyamatnak nincs kapcsolata más folyamatokkal."
      },
      "suggestions": {
        "title": "Javasolt folyamatok",
        "hint": "A lánc folyamataihoz kapcsolódik"
      }
    },
    "detail": {
      "noSubChains": "Nem találhatók alláncok.",
      "emptyChainHint": "Ez a lánc még nem tartalmaz folyamatokat vagy alláncokat."
    },
    "deleteChain": {
      "button": "Lánc törlése",
      "title": "Lánc törlése",
      "description": "Biztosan törölni szeretné a(z) \"{{name}}\" láncot?",
      "processesWillBeFreed": "{{count}} folyamat eltávolításra kerül a láncból",
      "childChainsWillBeDeleted": "{{count}} allánc szintén törlődik",
      "confirm": "Lánc törlése"
    },
    "drillDown": {
      "root": "Folyamatláncok",
      "childChains": "{{count}} allánc",
      "processes": "{{count}} folyamat",
      "emptyChain": "Ez a lánc még nem tartalmaz alláncokat vagy folyamatokat.",
      "createSubChain": "Allánc létrehozása",
      "createHere": "Új lánc létrehozása",
      "editProcesses": "Folyamatok szerkesztése"
    }
  },
  "flowKit": {
    "toolbar": {
      "fitView": "Nézet igazítása",
      "autoLayout": "Automatikus elrendezés",
      "undo": "Visszavonás",
      "redo": "Újra",
      "handTool": "Kéz eszköz (H)",
      "selectTool": "Kijelölő eszköz (V)"
    }
  },
  "stepTemplates": {
    "saveDialog": {
      "title": "Mentés lépéssablonként",
      "name": "Név",
      "description": "Leírás",
      "selectedCount_one": "{{count}} elem kiválasztva",
      "selectedCount_other": "{{count}} elem kiválasztva",
      "unnamedStep": "Névtelen lépés",
      "unnamedEvent": "Névtelen esemény",
      "save": "Mentés",
      "cancel": "Mégse",
      "saved": "A(z) „{{name}}” lépéssablon elmentve"
    },
    "insertDialog": {
      "title": "Lépéssablon beszúrása",
      "empty": "Még nincs mentett lépéssablon.",
      "loadError": "A lépéssablonok betöltése nem sikerült.",
      "insert": "Beszúrás",
      "cancel": "Mégse",
      "edit": "Szerkesztés",
      "delete": "Törlés",
      "save": "Mentés",
      "meta_one": "{{count}} elem · {{author}} · {{date}}",
      "meta_other": "{{count}} elem · {{author}} · {{date}}",
      "deleteConfirm": {
        "title": "Lépéssablon törlése",
        "body": "A(z) „{{name}}” véglegesen eltávolításra kerül a listáról. A már beszúrt lépések változatlanok maradnak."
      },
      "inserted": "A(z) „{{name}}” beszúrva"
    },
    "error": "A művelet sikertelen"
  }
}
